import { useEffect, useState } from "react";
export const useLoyaltyProductPoints = (items = []) => {
    const [totalPoints, setTotalPoints] = useState(0);
    useEffect(() => {
        setTotalPoints(items.reduce((prev, { points }) => prev + (points || 0), 0));
    }, [items]);
    return totalPoints;
};
//# sourceMappingURL=useLoyaltyProductPoints.js.map